import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const riskLocaleModule: LocaleModule = {
  name: "risk",
  messages: { en: en, it: it },
};
